//Bootstrap
"use strict";

import * as bootstrap from 'bootstrap';

//Feather Icons 
import feather from "feather-icons";
feather.replace();

//Anothers Files 
import './elements/stickyHeader';
import './elements/itemActiveNavbar';
